import { render } from "./AddEditPbMajor.vue?vue&type=template&id=4d9609cc&scoped=true"
import script from "./AddEditPbMajor.vue?vue&type=script&lang=js"
export * from "./AddEditPbMajor.vue?vue&type=script&lang=js"

import "./AddEditPbMajor.vue?vue&type=style&index=0&id=4d9609cc&scoped=true&lang=css"

import exportComponent from "D:\\newProjectGit\\HbzsbAdminClient\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d9609cc"]])

export default __exports__